import { useCallback, useEffect, useRef } from 'react'

export const useClickOutside = (callback: () => void) => {
  const containerRef = useRef<HTMLDivElement>(null)

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (!containerRef?.current) return

      // Check if the click was outside the container
      if (!containerRef.current.contains(event.target as Node)) {
        callback()
      }
    },
    [containerRef]
  )

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [handleClickOutside])

  return containerRef
}
